/* Halloween 2026 — Games section (aim / typing / lottery + HH2026 coupon sync) */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function ensureHH2026() {
    if (!window.HH2026) {
      window.HH2026 = { played: {}, bestCoupon: null, bonusShown: false };
    }
    if (!window.HH2026.played) window.HH2026.played = {};
    return window.HH2026;
  }

  function betterCoupon(a, b) {
    if (!a) return b;
    if (!b) return a;
    return b.off > a.off ? b : a;
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text);
      return;
    }
    var ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    document.body.removeChild(ta);
  }

  function parseConfig(root) {
    var el = root.querySelector('[data-hh2026-games-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  ready(function () {
    var root = document.querySelector('.halloween-2026-games');
    if (!root) return;

    var config = parseConfig(root);
    if (!config) return;

    var hh = ensureHH2026();
    var gamesById = {};
    (config.games || []).forEach(function (g) {
      if (g && g.game_id) gamesById[g.game_id] = g;
    });

    var publicCoupon = {
      code: config.public_coupon_code || 'GHOST15',
      off: Number(config.public_coupon_off) || 15
    };
    var lotteryPrizes = (config.lottery_prizes || []).filter(function (p) {
      return p && p.prize_id;
    });

    var stageEl = root.querySelector('#stage');
    var modalOverlay = root.querySelector('#game-modal-overlay');
    var doorsEl = root.querySelector('#doors');
    var activeCleanup = null;
    var WORDS = [
      'GHOST', 'WITCH', 'PUMPKIN', 'SKULL', 'GRAVE', 'SPELL', 'HAUNT', 'CURSE',
      'REAPER', 'SPIDER', 'COFFIN', 'SHADOW', 'FANG', 'POTION', 'RAVEN'
    ];
    var GLYPHS = { aim: '\uD83C\uDF83', typing: '\uD83D\uDC7B', lottery: '\uD83D\uDEAA' };

    function gameCoupon(gameId) {
      var g = gamesById[gameId];
      if (!g || !g.coupon_code) return null;
      return {
        code: g.coupon_code,
        off: Number(g.coupon_off) || 0,
        scope: g.coupon_scope || 'sitewide',
        label: g.coupon_label,
        note: g.coupon_note
      };
    }

    function setCoupon(c) {
      if (!c || !c.code) return;
      if (c.scope && c.scope !== 'sitewide') return;
      hh.bestCoupon = betterCoupon(hh.bestCoupon, c);
      window.dispatchEvent(
        new CustomEvent('HH2026:coupon', { detail: Object.assign({}, hh.bestCoupon) })
      );
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function shopLinkHtml(item) {
      if (!item || !item.shop_cta) return '';
      var scroll = item.shop_scroll || 'none';
      if (scroll === 'sale' || scroll === 'mystery' || scroll === 'giveaway') {
        return (
          '<p class="hh-picks-shop"><a data-scroll-' +
          scroll +
          '>' +
          esc(item.shop_cta) +
          '</a></p>'
        );
      }
      var href = item.shop_url || '#';
      return (
        '<p class="hh-picks-shop"><a href="' +
        esc(href) +
        '" target="_blank" rel="noopener noreferrer">' +
        esc(item.shop_cta) +
        '</a></p>'
      );
    }

    function updateCardButtons() {
      if (!doorsEl) return;
      doorsEl.querySelectorAll('.game-card').forEach(function (card) {
        var id = card.getAttribute('data-game');
        var btn = card.querySelector('[data-game-enter]');
        if (!btn || !id) return;
        var g = gamesById[id];
        var label = (g && g.btn_label) || 'Enter →';
        if (hh.played[id]) label = 'Play again';
        btn.textContent = label;
      });
    }

    function finishGame(gameId, prize) {
      hh.played[gameId] = true;
      var c = prize
        ? {
            code: prize.coupon_code,
            off: Number(prize.coupon_off) || 0,
            scope: prize.coupon_scope || 'none'
          }
        : gameCoupon(gameId);
      if (c && c.code && !prize) setCoupon(c);
      if (prize && prize.coupon_code && prize.coupon_scope === 'sitewide' && !prize.is_trick) {
        setCoupon(c);
      }

      // Trick doors keep play state but do not add GHOST15 (public code) into lottery rewards.
      var rewardCode = prize
        ? prize.is_trick
          ? ''
          : prize.coupon_code
        : c && c.code
          ? c.code
          : '';
      var shopSource = prize && !prize.is_trick ? prize : gamesById[gameId] || {};
      window.dispatchEvent(
        new CustomEvent('HH2026:game-played', {
          detail: {
            gameId: gameId,
            coupon: rewardCode,
            shopUrl: rewardCode ? shopSource.shop_url || '' : '',
            shopScroll: rewardCode ? shopSource.shop_scroll || 'none' : 'none',
            shopLabel: rewardCode
              ? shopSource.shop_button_label || shopSource.shop_cta || ''
              : '',
            couponScope: rewardCode ? shopSource.coupon_scope || 'none' : 'none'
          }
        })
      );

      updateCardButtons();
      return false;
    }

    function couponBlockHtml(item) {
      if (!item) return '';
      if (item.is_trick) {
        return (
          (item.main_text ? '<div class="trick-main">' + esc(item.main_text) + '</div>' : '') +
          (item.supporting_text ? '<p class="stat-line">' + esc(item.supporting_text) + '</p>' : '') +
          shopLinkHtml(item)
        );
      }
      if (!item.coupon_code) return shopLinkHtml(item);
      var label = item.coupon_label || ('YOUR COUPON · ' + (item.coupon_off || '') + '% OFF');
      var note =
        item.coupon_note ||
        ('Beats the public ' + publicCoupon.off + '%. Use this one code at checkout.');
      return (
        '<div class="coupon-box" data-code="' +
        esc(item.coupon_code) +
        '">' +
        '<div class="label">' +
        esc(label) +
        '</div>' +
        '<div class="code-line"><span class="code">' +
        esc(item.coupon_code) +
        '</span><button class="copy" type="button">Copy</button></div>' +
        '<div class="note">' +
        esc(note) +
        '</div></div>' +
        shopLinkHtml(item)
      );
    }

    function resultFooter(gameId) {
      var g = gamesById[gameId] || {};
      var msg =
        g.result_message ||
        "\uD83C\uDF6C Trick or treat – treat. Here's your pick and a coupon to take home this Halloween.";
      return (
        (msg ? '<div class="tie">' + esc(msg) + '</div>' : '') +
        '<div data-hh-picks-mount="' +
        gameId +
        '"></div>' +
        couponBlockHtml(g)
      );
    }

    function wirePick(card) {
      var dataEl = card.querySelector('[data-hh-variants]');
      if (!dataEl) return;
      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var selects = Array.prototype.slice.call(card.querySelectorAll('[data-hh-option]'));
      var priceEl = card.querySelector('[data-hh-price]');
      var imgEl = card.querySelector('[data-hh-img]');
      var addBtn = card.querySelector('add-cart-button');

      function match() {
        var opts = selects.map(function (s) {
          return s.value;
        });
        return (
          variants.find(function (v) {
            return opts.every(function (val, i) {
              return v.options[i] === val;
            });
          }) ||
          variants.find(function (v) {
            return v.available;
          }) ||
          variants[0]
        );
      }

      function apply() {
        var v = match();
        if (!v) return;
        if (priceEl) priceEl.textContent = v.price;
        if (imgEl && v.image) imgEl.src = v.image;
        if (!addBtn) return;
        addBtn.setAttribute('data-variant-id', String(v.id));
        if (v.available) {
          addBtn.removeAttribute('aria-disabled');
          addBtn.classList.remove('is-disabled');
        } else {
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.classList.add('is-disabled');
        }
      }

      if (addBtn) {
        addBtn.addEventListener(
          'click',
          function (e) {
            if (addBtn.classList.contains('is-disabled')) {
              e.stopImmediatePropagation();
              e.preventDefault();
            }
          },
          true
        );
      }
      selects.forEach(function (s) {
        s.addEventListener('change', apply);
      });
      apply();
    }

    function attachPicks(scope, pickKey) {
      var mount = scope.querySelector('[data-hh-picks-mount]');
      if (!mount) return;
      var tpl = root.querySelector('template[data-hh-game-picks="' + pickKey + '"]');
      if (!tpl || !tpl.content.querySelector('.hh-pick')) {
        mount.remove();
        return;
      }
      var wrap = document.createElement('div');
      wrap.className = 'hh-picks';
      wrap.appendChild(tpl.content.cloneNode(true));
      mount.replaceWith(wrap);
      wrap.querySelectorAll('[data-hh-pick]').forEach(wirePick);
    }

    function wireResult(scope, pickKey, copyCode) {
      attachPicks(scope, pickKey);
      var cb = scope.querySelector('.coupon-box .copy');
      if (cb && copyCode) {
        cb.addEventListener('click', function (e) {
          copyText(copyCode);
          e.target.textContent = 'Copied ✓';
        });
      }
      function bindScroll(sel, id) {
        scope.querySelectorAll(sel).forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.preventDefault();
            var target = document.getElementById(id);
            if (target) target.scrollIntoView({ behavior: 'smooth' });
          });
        });
      }
      bindScroll('[data-scroll-gv]', 'giveaway');
      bindScroll('[data-scroll-giveaway]', 'giveaway');
      bindScroll('[data-scroll-sale]', 'sale');
      bindScroll('[data-scroll-mystery]', 'mystery-box');
    }

    function backHome() {
      if (activeCleanup) {
        activeCleanup();
        activeCleanup = null;
      }
      if (modalOverlay) modalOverlay.classList.remove('open');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (stageEl) stageEl.innerHTML = '';
      }, 280);
      updateCardButtons();
    }

    function panel(title, glyph, bodyHtml) {
      stageEl.innerHTML =
        '<div class="panel"><div class="panel-head"><h2><span class="glyph">' +
        glyph +
        '</span>' +
        title +
        '</h2>' +
        '<button class="back" id="back-btn" type="button">✕ Close</button></div>' +
        '<div class="panel-body" id="pbody">' +
        bodyHtml +
        '</div></div>';
      document.getElementById('back-btn').addEventListener('click', backHome);
      return document.getElementById('pbody');
    }

    function mountAim() {
      var g = gamesById.aim || {};
      var name = g.name || 'Pumpkin Smash';
      var body = panel(
        name,
        GLYPHS.aim,
        '<p class="lead">Pumpkins rise from the dark — <b>see it, smash it</b>. 20 seconds of pure reflex and aim.</p>' +
          '<div class="center"><button class="btn amber" id="aim-start" type="button">Light the candle \uD83D\uDD25</button></div>'
      );
      document.getElementById('aim-start').addEventListener('click', function () {
        runAim(body);
      });
    }

    function runAim(body) {
      var hits = 0;
      var empties = 0;
      var reactions = [];
      var time = 20;
      var spawnT = null;
      var tickT = null;
      body.innerHTML =
        '<div class="hud"><div class="h"><div class="v" id="a-hit">0</div><div class="k">Hits</div></div>' +
        '<div class="h red"><div class="v" id="a-time">20</div><div class="k">Seconds</div></div>' +
        '<div class="h"><div class="v" id="a-acc">100%</div><div class="k">Accuracy</div></div></div>' +
        '<div id="aim-field"></div><p class="lead" style="margin-top:10px">Mouse on desktop, finger on mobile</p>';
      var field = document.getElementById('aim-field');
      var setAcc = function () {
        var t = hits + empties;
        document.getElementById('a-acc').textContent = (t ? Math.round((hits / t) * 100) : 100) + '%';
      };
      var emojis = ['\uD83C\uDF83', '\uD83D\uDC7B', '\uD83E\uDD87', '\uD83D\uDC80'];
      field.addEventListener('pointerdown', function (e) {
        if (e.target === field) {
          empties++;
          setAcc();
        }
      });
      function spawn() {
        var t = document.createElement('button');
        t.className = 'tgt';
        t.type = 'button';
        t.textContent = emojis[(Math.random() * emojis.length) | 0];
        t.style.left = 8 + Math.random() * 84 + '%';
        t.style.top = 12 + Math.random() * 76 + '%';
        t.setAttribute('aria-label', 'smash');
        var born = performance.now();
        var life = setTimeout(function () {
          if (t.isConnected) t.remove();
        }, 1050);
        t.addEventListener('pointerdown', function (ev) {
          ev.stopPropagation();
          clearTimeout(life);
          hits++;
          reactions.push(performance.now() - born);
          document.getElementById('a-hit').textContent = hits;
          setAcc();
          t.classList.add('gone');
          setTimeout(function () {
            t.remove();
          }, 180);
        });
        field.appendChild(t);
      }
      spawnT = setInterval(spawn, 640);
      spawn();
      tickT = setInterval(function () {
        time--;
        document.getElementById('a-time').textContent = time;
        if (time <= 0) end();
      }, 1000);
      activeCleanup = function () {
        clearInterval(spawnT);
        clearInterval(tickT);
      };
      function end() {
        clearInterval(spawnT);
        clearInterval(tickT);
        activeCleanup = null;
        field.querySelectorAll('.tgt').forEach(function (t) {
          t.remove();
        });
        var avg = reactions.length
          ? Math.round(reactions.reduce(function (a, b) {
              return a + b;
            }, 0) / reactions.length)
          : 0;
        var acc = hits + empties ? Math.round((hits / (hits + empties)) * 100) : 0;
        finishGame('aim');
        var aimGame = gamesById.aim || {};
        body.innerHTML =
          '<div class="result">' +
          '<div class="result-badge">' +
          esc(aimGame.result_badge || '\uD83C\uDF83 Pumpkin Smashed!') +
          '</div>' +
          '<p class="stat-line">Your average reaction</p>' +
          '<div class="big">' +
          (avg || '–') +
          '<small> ms</small></div>' +
          '<p class="stat-line">' +
          hits +
          ' hits · ' +
          acc +
          '% accuracy</p>' +
          resultFooter('aim') +
          '<div class="center" style="margin-top:16px"><button class="btn ghost" id="a-retry" type="button">Play again</button></div>' +
          '</div>';
        wireResult(body, 'aim', (aimGame.coupon_code || 'SMASH20'));
        document.getElementById('a-retry').addEventListener('click', function () {
          runAim(body);
        });
      }
    }

    function mountTyping() {
      var g = gamesById.typing || {};
      var name = g.name || 'Type the Exorcism';
      var body = panel(
        name,
        GLYPHS.typing,
        '<p class="lead">Spirits fall carrying a spell — <b>type the word to banish them</b>. 25 seconds.</p>' +
          '<div class="center"><button class="btn amber" id="t-start" type="button">Begin the rite \uD83D\uDD4A️</button></div>'
      );
      document.getElementById('t-start').addEventListener('click', function () {
        runTyping(body);
      });
    }

    function runTyping(body) {
      var banished = 0;
      var escaped = 0;
      var time = 25;
      var spawnT = null;
      var tickT = null;
      body.innerHTML =
        '<div class="hud"><div class="h"><div class="v" id="t-ban">0</div><div class="k">Banished</div></div>' +
        '<div class="h red"><div class="v" id="t-time">25</div><div class="k">Seconds</div></div>' +
        '<div class="h"><div class="v" id="t-esc">0</div><div class="k">Escaped</div></div></div>' +
        '<div id="type-field"></div>' +
        '<input class="type-input" id="t-input" placeholder="Type the spell to banish it…" autocomplete="off" autocapitalize="characters" spellcheck="false">';
      var field = document.getElementById('type-field');
      var input = document.getElementById('t-input');
      input.focus();
      var H = field.clientHeight || 340;
      function spawn() {
        var w = document.createElement('div');
        w.className = 'word';
        var text = WORDS[(Math.random() * WORDS.length) | 0];
        w.dataset.text = text;
        w.innerHTML = '<span class="g">\uD83D\uDC7B</span>' + text;
        w.style.left = 6 + Math.random() * 70 + '%';
        field.appendChild(w);
        var dur = 5200 + Math.random() * 1400;
        var start = performance.now();
        (function fall(now) {
          var p = (now - start) / dur;
          w.style.top = p * (H + 30) - 30 + 'px';
          if (p >= 1) {
            if (w.isConnected) {
              w.remove();
              escaped++;
              document.getElementById('t-esc').textContent = escaped;
            }
            return;
          }
          w._raf = requestAnimationFrame(fall);
        })(start);
      }
      input.addEventListener('input', function () {
        var v = input.value.trim().toUpperCase();
        if (!v) return;
        var target = Array.prototype.slice
          .call(field.querySelectorAll('.word'))
          .find(function (w) {
            return w.dataset.text === v;
          });
        if (target) {
          cancelAnimationFrame(target._raf);
          target.classList.add('hit');
          setTimeout(function () {
            target.remove();
          }, 160);
          banished++;
          document.getElementById('t-ban').textContent = banished;
          input.value = '';
        }
      });
      spawnT = setInterval(spawn, 1500);
      spawn();
      tickT = setInterval(function () {
        time--;
        document.getElementById('t-time').textContent = time;
        if (time <= 0) end();
      }, 1000);
      activeCleanup = function () {
        clearInterval(spawnT);
        clearInterval(tickT);
        field.querySelectorAll('.word').forEach(function (w) {
          cancelAnimationFrame(w._raf);
        });
      };
      function end() {
        clearInterval(spawnT);
        clearInterval(tickT);
        field.querySelectorAll('.word').forEach(function (w) {
          cancelAnimationFrame(w._raf);
          w.remove();
        });
        activeCleanup = null;
        var total = banished + escaped;
        var acc = total ? Math.round((banished / total) * 100) : 0;
        finishGame('typing');
        var typeGame = gamesById.typing || {};
        body.innerHTML =
          '<div class="result">' +
          '<div class="result-badge">' +
          esc(typeGame.result_badge || '\uD83D\uDC7B You\'ve Unlocked a Scary Good Deal!') +
          '</div>' +
          '<p class="stat-line">You banished</p>' +
          '<div class="big">' +
          banished +
          '<small> spirits</small></div>' +
          '<p class="stat-line">' +
          acc +
          '% accuracy · ' +
          escaped +
          ' escaped</p>' +
          resultFooter('typing') +
          '<div class="center" style="margin-top:16px"><button class="btn ghost" id="t-retry" type="button">Play again</button></div>' +
          '</div>';
        wireResult(body, 'typing', typeGame.coupon_code || 'SCARY25');
        document.getElementById('t-retry').addEventListener('click', function () {
          runTyping(body);
        });
      }
    }

    function shuffle(list) {
      var arr = list.slice();
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
      }
      return arr;
    }

    function mountLottery() {
      var g = gamesById.lottery || {};
      var name = g.name || 'Trick or Treat';
      var body = panel(
        name,
        GLYPHS.lottery,
        '<p class="lead">Five doors, a treat behind each. <b>Knock once</b> — trust your gut.</p>' +
          '<div class="lot-doors" id="lot"></div>'
      );
      var lot = document.getElementById('lot');
      var doorCount = 5;
      var assigned = lotteryPrizes.length ? shuffle(lotteryPrizes) : [];
      lot.innerHTML = Array.from({ length: doorCount })
        .map(function (_n, i) {
          var prize = assigned[i % Math.max(assigned.length, 1)];
          var pid = prize && prize.prize_id ? prize.prize_id : '';
          return (
            '<button class="lot-door" type="button" data-i="' +
            i +
            '" data-prize-id="' +
            esc(pid) +
            '" aria-label="Knock on door ' +
            (i + 1) +
            '">\uD83D\uDEAA</button>'
          );
        })
        .join('');
      lot.querySelectorAll('.lot-door').forEach(function (d) {
        d.addEventListener('click', function () {
          lot.querySelectorAll('.lot-door').forEach(function (x) {
            x.disabled = true;
          });
          d.classList.add('win');
          d.textContent = d.getAttribute('data-prize-id') === 'trick' ? '\uD83D\uDC7B' : '\uD83C\uDF81';
          var prizeId = d.getAttribute('data-prize-id');
          setTimeout(function () {
            reveal(body, prizeId);
          }, 550);
        });
      });
    }

    function reveal(body, prizeId) {
      var prize =
        lotteryPrizes.find(function (p) {
          return p.prize_id === prizeId;
        }) ||
        lotteryPrizes[0] ||
        {};
      finishGame('lottery', prize);
      var pickKey = prize.prize_id ? 'prize-' + prize.prize_id : 'lottery';
      body.innerHTML =
        '<div class="result">' +
        (prize.title ? '<h3 class="result-title">' + esc(prize.title) + '</h3>' : '') +
        '<div class="result-badge">' +
        esc(prize.badge || '\uD83C\uDF83 Behind the door') +
        '</div>' +
        (prize.message ? '<div class="tie">' + esc(prize.message) + '</div>' : '') +
        '<div data-hh-picks-mount="' +
        esc(pickKey) +
        '"></div>' +
        couponBlockHtml(prize) +
        '</div>';
      wireResult(body, pickKey, prize.is_trick ? '' : prize.coupon_code);
    }

    var mounts = { aim: mountAim, typing: mountTyping, lottery: mountLottery };

    function openGame(id) {
      if (!mounts[id] || !stageEl || !modalOverlay) return;
      if (activeCleanup) {
        activeCleanup();
        activeCleanup = null;
      }
      stageEl.innerHTML = '';
      modalOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      mounts[id]();
    }

    hh.openGame = openGame;
    window.addEventListener('HH2026:open-game', function (e) {
      var detail = (e && e.detail) || {};
      if (detail.gameId) openGame(detail.gameId);
    });

    if (doorsEl) {
      doorsEl.querySelectorAll('.game-card').forEach(function (card) {
        var btn = card.querySelector('[data-game-enter]');
        if (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            openGame(card.getAttribute('data-game'));
          });
        }
      });
    }

    if (modalOverlay) {
      modalOverlay.addEventListener('click', function (e) {
        if (e.target === modalOverlay) backHome();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalOverlay && modalOverlay.classList.contains('open')) {
        backHome();
      }
    });

    updateCardButtons();
  });
})();
